module.exports = __webpack_public_path__ + "static/img/17.3728845.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting790/images/17.png
// module id = muT4
// module chunks = 4